"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var react_1 = __importDefault(require("react"));
var AccessAuthenticationPageStateContext_1 = require("./AccessAuthenticationPageStateContext");
var styles = __importStar(require("./ChooseVerificationMethod.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var clerk_react_1 = require("@clerk/clerk-react");
var SpringboardUserCard_1 = require("@CommonFrontend/Public/Springboard/UserCard/SpringboardUserCard");
var identityService_1 = require("./identityService");
var AccessAuthenticationTelemetry_1 = require("./AccessAuthenticationTelemetry");
var ChooseVerificationMethod = function (_a) {
    var previewImage = _a.previewImage, signupUrl = _a.signupUrl, loginUrl = _a.loginUrl, submitUrl = _a.submitUrl, triggerPulse = _a.triggerPulse, setPageUnlocked = _a.setPageUnlocked, emailVerificationEnabled = _a.emailVerificationEnabled, identifySubmissionError = _a.identifySubmissionError, setIdentifySubmissionError = _a.setIdentifySubmissionError;
    var _b = (0, clerk_react_1.useAuth)(), isSignedIn = _b.isSignedIn, signOut = _b.signOut, getToken = _b.getToken;
    var telemetry = (0, AccessAuthenticationTelemetry_1.useAccessAuthTelemetry)();
    var pageContext = (0, AccessAuthenticationPageStateContext_1.useAccessAuthPageState)();
    var handleClickContinueWithEmail = function () {
        telemetry.track("Clicked Access Auth Method", {
            type: "email",
        });
        pageContext.setPageState({ page: "verify your details" });
    };
    var handleContinueWithSpringboard = function () { return __awaiter(void 0, void 0, Promise, function () {
        var clerkToken, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIdentifySubmissionError("");
                    triggerPulse();
                    return [4, getToken()];
                case 1:
                    clerkToken = _a.sent();
                    if (!clerkToken) {
                        return [2];
                    }
                    return [4, (0, identityService_1.identifyWithSpringboard)({ submitUrl: submitUrl, clerkToken: clerkToken })];
                case 2:
                    result = _a.sent();
                    if (result.ok !== true) {
                        return [2, setIdentifySubmissionError(result.error)];
                    }
                    setPageUnlocked(true);
                    setTimeout(function () {
                        triggerPulse();
                        window.location.href = result.redirectUrl;
                    }, kaleidoscope_1.AnimationDuration.Long + 1000);
                    return [2];
            }
        });
    }); };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: styles.imageContainer },
            react_1.default.createElement("img", { src: previewImage, alt: "Qwilr page preview", className: styles.image, width: 1200, height: 627 })),
        react_1.default.createElement("div", { className: styles.card },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "5", strong: true }, "Verify your details to access this protected Qwilr page"),
            isSignedIn ? (react_1.default.createElement("div", { className: styles.signedInWrapper },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(clerk_react_1.SignedIn, null,
                        react_1.default.createElement(SpringboardUserCard_1.SpringboardUserCard, null))),
                react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: !!identifySubmissionError }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef },
                        react_1.default.createElement(kaleidoscope_1.Alert, { heading: identifySubmissionError === identityService_1.SubmitErrors.NoAccess ? "No Access" : "Error", alertType: kaleidoscope_1.AlertType.Error }, identifySubmissionError)));
                }),
                react_1.default.createElement("div", { className: styles.signedInOptions },
                    react_1.default.createElement(kaleidoscope_1.Button, { width: "full", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        window.localStorage.setItem(identityService_1.autoIdentifyOnLoadKey, "true");
                                        telemetry.track("Clicked Switch Springboard Account", {
                                            source: "springboard",
                                        });
                                        return [4, signOut()];
                                    case 1:
                                        _a.sent();
                                        window.location.href = loginUrl;
                                        return [2];
                                }
                            });
                        }); }, type: kaleidoscope_1.ButtonType.Secondary },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Switch accounts")),
                    react_1.default.createElement(kaleidoscope_1.Button, { width: "full", onClick: handleContinueWithSpringboard },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, className: styles.buttonText }, "Continue"))))) : (react_1.default.createElement("div", { className: styles.options },
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Create a free Qwilr Springboard account to remember your details and make it easier to access pages"),
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.verificationMethodButton, type: kaleidoscope_1.ButtonType.Secondary, width: "full", onClick: function () {
                        window.localStorage.setItem(identityService_1.autoIdentifyOnLoadKey, "true");
                        telemetry.track("Clicked Access Auth Method", {
                            type: "springboard",
                        });
                    }, href: function () { return signupUrl; }, openInSameTab: true },
                    react_1.default.createElement("div", { className: styles.verificationMethodInner },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(icons_1.Qwilr, null)),
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Create a Qwilr Springboard account"))),
                emailVerificationEnabled && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: styles.orWrapper },
                        react_1.default.createElement("div", { className: styles.orLine }),
                        react_1.default.createElement("div", { className: styles.orTextWrapper },
                            react_1.default.createElement(kaleidoscope_1.Label, { size: "m", className: styles.orText }, "or"))),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: styles.verificationMethodButton, type: kaleidoscope_1.ButtonType.Secondary, onClick: handleClickContinueWithEmail, width: "full" },
                        react_1.default.createElement("div", { className: styles.verificationMethodInner },
                            react_1.default.createElement("span", { className: styles.verificationMethodButtonIcon },
                                react_1.default.createElement(icons_1.Mail, null)),
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, "Continue with email"))))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s" },
                    "Already have an account?",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { onClick: function () { return window.localStorage.setItem(identityService_1.autoIdentifyOnLoadKey, "true"); }, href: loginUrl, target: "" }, "Log in"))))));
};
exports.default = ChooseVerificationMethod;
